var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", style: _vm.style },
    [
      _c(
        "Signature",
        {
          attrs: { closable: _vm.closable },
          on: {
            close: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _vm.meta.processType === "numerar"
            ? _vm._t("default", [
                _c("div", { staticClass: "data-item-numeration" }, [
                  _vm._v("NNN")
                ])
              ])
            : _vm._e(),
          _vm.meta.processType === "tramitar"
            ? _vm._t("default", [
                _c("div", { staticClass: "data-item-process" }, [_vm._v("T")])
              ])
            : _vm._e(),
          _vm.meta.processType === "fechar"
            ? _vm._t("default", [
                _c("div", { staticClass: "data-item-date" }, [
                  _vm._v(" 2022-04-01")
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }